import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        drlRequirementCompetence: '<',
        onClose: '&',
        onUpdate: '&'
    },
    template: `
            <div class="modal-header">
                <button type="button" class="close" ng-click="vm.onClose()"></button>
                <h2>{{ 'user.Edit Requirement' | translate }}</h2>
            </div>
            <form ng-submit="vm.save()" class="form">
                <div class="modal-body">
                    <ul class="items06 type02">
                        <li>
                            <div class="form">
                                <form-row error="vm.form.errors.competenceId">
                                    <label class="label">{{ 'user.Competence' | translate }}</label>
                                    <div class="items">
                                        <select class="form-control" ng-change="vm.updateSkills()" ng-model="vm.form.model.competenceId">
                                            <option value=""></option>
                                            <option value="{{ item.id }}" ng-repeat="item in vm.competences">
                                               {{ item.name }}
                                            </option>
                                        </select>
                                        <form-row-error></form-row-error>
                                    </div>
                                </form-row>
                                <form-row error="vm.form.errors.type">
                                    <label class="label">Type</label>
                                    <div class="items">
                                        <ul class="checkboxes">
                                            <li>
                                                <label>
                                                <input
                                                     ng-model="vm.form.model.type"
                                                     type="radio"
                                                     value="{{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.KEYS.MANDATORY }}">
                                                    {{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.LABELS.MANDATORY }}
                                                </label>
                                                <label>
                                                    <input
                                                     ng-model="vm.form.model.type"
                                                     type="radio"
                                                     value="{{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.KEYS.OPTIONAL }}">
                                                  {{ vm.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM.LABELS.OPTIONAL }}
                                                </label>
                                            </li>
                                        </ul>
                                    </div>
                                </form-row>
                            </div>
                        </li>
                    </ul>
                    <ul class="actions01">
                        <li><a class="btn view" ng-click="vm.toggleSkills()">{{ 'user.Show related skills' | translate }}</a></li>
                    </ul>
                    <div class="terms01" ng-if="vm.openSkillModal === true">
                        <form-row error="vm.form.errors.skills[index].level" ng-repeat="(index, competenceSkill) in vm.form.model.skills">
                            <label class="label">{{ competenceSkill.name }}</label>
                            <div class="items">
                                <input type="hidden" class="form-control" ng-value="competenceSkill.skillId" ng-model="vm.form.model.skills[index].skillId"/>
                                <input class="form-control" ng-model="vm.form.model.skills[index].level"/>
                                <form-row-error></form-row-error>
                            </div>
                        </form-row>
                    </div>
                </div>
                <div class="modal-footer">
                    <ul class="actions01">
                        <li class="primary"><button class="btn main" type="button" ng-click="vm.save()">Save</button></li>
                        <li><button class="btn discrete" type="button" ng-click="vm.onClose()">Cancel</button></li>
                    </ul>
                </div>
            </form>
    `
})
export default class {
    constructor (FormFactory, SkillResource, CompetenceResource, CompetenceRequirementResource, USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM, CLASSIFIER_ENUM) {
        this.FormFactory = FormFactory;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM = USER_COMPETENCE_REQUIREMENT_COMPETENCE_TYPE_ENUM;
        this.CompetenceResource = CompetenceResource;
        this.SkillResource = SkillResource;
        this.CompetenceRequirementResource = CompetenceRequirementResource;
    }

    $onInit () {
        /** Adds "correct" value to model **/
        this.drlRequirementCompetence.competenceId += '';
        this.form = this.FormFactory.create(new this.CompetenceRequirementResource, model => {
            const formData = { id: model.id, competenceId: model.competenceId, type: model.type };
            return this.CompetenceRequirementResource.updateCompetence({ id: model.competenceRequirementSetId, expand: 'competency' }, formData).$promise;
        });
        this.form.model = this.drlRequirementCompetence;

        this.CompetenceResource.query({ pageSize: 0 }).$promise.then((competences) => {
            this.competences = competences;
        });

        this.initSkills();
    }

    save () {
        return this.form.save().then((updatedRequirement) => {
            return this.onUpdate({ updatedRequirement });
        });
    }

    toggleSkills () {
        this.openSkillModal = !this.openSkillModal;
    }

    fetchSkills () {
        const searchParams = { 'competenceId[]': this.form.model.competenceId, expand: 'competence,skill,requirementSetSkill', requirementSetId: this.form.model.competenceRequirementSetId };
        return this.SkillResource.competenceSkills(searchParams).$promise;
    }

    initSkills () {
        this.fetchSkills().then(competenceSkills => {
            this.form.model.skills = competenceSkills.map(item => ({ skillId: item.skillId, level: item.requirementSetSkill.level, name: item.skill.name }));
            this.form.model.errors = {};
        });
    }

    updateSkills () {
        this.fetchSkills().then(competenceSkills => {
            const duplicatedSkillIds = competenceSkills.filter((competenceSkill) => {
                return this.form.model.skills.map(item => item.skillId).indexOf(competenceSkill.skillId) !== -1;
            }).map(item => item.skillId);

            const newSkills = competenceSkills.filter(competenceSkill => duplicatedSkillIds.indexOf(competenceSkill.skillId) === -1);
            const oldSkills = this.form.model.skills.filter(editedSkill => duplicatedSkillIds.indexOf(editedSkill.skillId) !== -1);

            this.form.model.skills = oldSkills.concat(newSkills.map(item => ({ skillId: item.skillId, level: null, name: item.skill.name })));
            this.form.model.errors = {};
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/competence/requirements/editCompetence/index.js